module.exports = __webpack_public_path__ + "img/zona2.9e483ad2.jpg";